import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Row, Checkbox, Form, Table, Input, DatePicker, Tooltip, Select } from "antd";
import { useTranslation } from 'react-i18next';
import HTTPService from "../../../utils/makerequest";
import { IPageProps } from "../../../interfaces/page-data";
import { Toast } from 'primereact/toast';
import '../CountingManagement/AddCounting.css';
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { ICampusData } from "../../../interfaces/ICampusData";
import { ILocationData } from "../../../interfaces/ILocationData";
import { DeleteOutlined, TableOutlined, UserOutlined, SaveOutlined, CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";

import { IUser } from "../../../interfaces/ICountingData";
import { IAllCampusWithLocation } from "../../../interfaces/IAllCampusWithLocation";
import { StateLoader } from "../../../redux/StateLoader";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { ICompanyData } from "../../../interfaces/ICompanyData";


const CountingAdd: React.FunctionComponent<IPageProps> = () => {
    const toast = useRef<any>(null);
    const loader = new StateLoader();
    const userInfo: IAuthentication = loader.loadAuthState();
    const { t } = useTranslation();

    //const [countingData, setCountingData] = useState<ICountingData>({}); // sayım bilgisi ve lokasyon bilgisi(campus bilgisi)
    const [countingJobLocationTBL, setCountingJobLocationTBL] = useState<any[]>([]);
    const [countingJobResponsibleTBL, setCountingJobResponsibleTBL] = useState<any[]>([]);
    const [companyData, setCompanyData] = useState<ICompanyData[]>([]);

    const [selectedCampus, setSelectedCampus] = useState<ICampusData[]>([]); // seçilen kampüsler
    const [selectedLocation, setSelectedLocation] = useState<ILocationData[]>([]); // seçilen lokasyonlar
    const [selectedUser, setSelectedUser] = useState<IUser[]>([]); // seçilen userlar

    const [userData, setUserData] = useState([]);
    const [filteredUserData, setFilteredUserData] = useState([]); // üstte tablodaki userlar
    const [allCampusWithLocation, setAllCampusWithLocation] = useState<IAllCampusWithLocation[]>([]); // üstte tablodaki lokasyon ve kampüs

    const [form] = Form.useForm();
    const [searchText, setSearchText] = useState('')
    const [searchTextLocation, setSearchTextLocation] = useState('');

    const handleCancel = () => {
        window.location.replace("/admin/counting-management/");
    };

    useEffect(() => {
        fetchCompanyData();
        if (userInfo?.companyId) {
            fetchUser(userInfo?.companyId)
            getCampusWithLocation(userInfo?.companyId)
        }
    }, []);

    const fetchCompanyData = async () => {
        try {
            const result = await HTTPService.GETCompanyNames();
            setCompanyData(result);
        } catch (error) {
            console.error("Şirket verilerini alırken bir hata oluştu:", error);
        }
    };


    const handleAddToTable = () => {
        selectedLocation.forEach(row => {
            const newSaveObj = {
                countingJobId: 0,
                locationId: row.locationId,
                locationTBL: row,
                campusTBL: row.campusTBL,
                locationName: row.locationName,
                countingJobResponsibleTBL: [],
            };

            selectedUser.forEach(user => {
                const newCountingJobResponsible = {
                    countingJobId: 0,
                    responsibleUserId: user.userId,
                    locationId: row.locationId,
                    isNotification: false,
                    responsibleUserTBL: user,
                    locationTBL: row,
                };
                newSaveObj.countingJobResponsibleTBL.push(newCountingJobResponsible);
            });

            setCountingJobLocationTBL(prevState => [...prevState, newSaveObj]);
            setCountingJobResponsibleTBL(prevState => [...prevState, ...newSaveObj.countingJobResponsibleTBL]);
        });


        toast.current?.show({
            severity: 'warn',
            summary: t('Warning'),
            detail: t('dates_valid'),
            life: 3000
        });

        //setSelectedLocation([]); // temizleme işlemi
        setSelectedUser([]);
    };

    const handleDeleteRow = (countingJobLocationId: number, campusId: number, locationId: number) => {
        // Lokasyonları filtrelerken, sadece doğru locationId'ye sahip olanları sil
        const updatedLocationTBL = countingJobLocationTBL.filter(
            item => item.locationTBL.locationId !== locationId // locationId'ye göre filtreleme yapıyoruz
        );
        setCountingJobLocationTBL(updatedLocationTBL);

        // İlgili lokasyonun responsible verilerini filtrele
        const updatedResponsibleTBL = countingJobResponsibleTBL.filter(
            responsible => responsible.locationTBL.locationId !== locationId // locationId'ye göre filtreleme yapıyoruz
        );
        setCountingJobResponsibleTBL(updatedResponsibleTBL);
    };



    const handleCampusChange = (values: CheckboxValueType[]) => {
        let tmp: ILocationData[] = [];

        if (values.includes('selectAllCampus')) {
            // allCampusWithLocation.forEach(row => {
            //     row.locationTBL.forEach(location => {
            //         tmp.push({
            //             ...location,
            //             campus: {
            //                 campusId: row.campusId,
            //                 campusName: row.campusName
            //             }
            //         });
            //     });
            // });
            // setSelectedLocation(tmp);
            // setSelectedCampus(allCampusWithLocation); 
        } else {
            const selected = allCampusWithLocation?.filter(row =>
                values.includes(row.campusId)
            );

            setSelectedCampus(selected);

            // selected.forEach(row => {
            //     row.locationTBL.forEach(location => {
            //         if (values.includes(location.locationId)) {
            //             const updatedLocation = {
            //                 ...location,
            //                 campus: {
            //                     campusId: row.campusId,
            //                     campusName: row.campusName
            //                 }
            //             };
            //             tmp.push(updatedLocation);
            //         }
            //     });
            // });

            // setSelectedLocation(tmp);
        }
    };


    const handleLocationChange = (values: CheckboxValueType[]) => {
        let tmp: ILocationData[] = [];

        if (values.includes('selectAll')) {
            // const allLocations = allCampusWithLocation.flatMap(row => row.locationTBL);

            // allLocations.forEach(location => {
            //     tmp.push({
            //         ...location,
            //         isSelected: true, 
            //     });
            // });

            // setSelectedLocation(tmp); 
        } else {
            allCampusWithLocation.filter(row =>
                row.locationTBL.some(location => values.includes(location.locationId))
            ).map(row => {
                row.locationTBL.forEach(location => {
                    if (values.includes(location.locationId)) {
                        tmp.push({
                            locationId: location.locationId,
                            campusId: row.campusId,
                            locationName: location.locationName,
                            campusTBL: row,
                        });
                    }
                });
            });

            setSelectedLocation(tmp);
        }
    };

    const handleUserChange = (values: any[]) => {
        // selectedUsers dizisini kullanıcı verileriyle güncelle
        const selectedUsers = userData.filter(user => values.includes(user.userId));
        setSelectedUser(selectedUsers);

    };



    const fetchUser = async (companyId: number) => {
        try {
            const result = await HTTPService.GETUserNames(companyId);
            setUserData(result);
            setFilteredUserData(result); // Başlangıçta tüm kullanıcıları filteredUserData'ya da set ediyoruz
        } catch (error) {
            toast.current?.show({
                severity: 'error',
                summary: t('mistake'),
                detail: t('error'),
                life: 3000
            });
        }
    };

    const getCampusWithLocation = (id: number) => {
        HTTPService.GET(`/Campus/allCampusWithLocationByCompany?companyId=${id}`)
            .then(response => {
                if (!response.data) {
                    return;
                }
                setAllCampusWithLocation(response.data);
            })
            .catch(error => {
                console.error('Error fetching pie data:', error);
            });
    };

    const registerCounting = async (values) => {
        if (countingJobLocationTBL.length === 0) {
            toast.current?.show({
                severity: 'error',
                summary: t('mistake'),
                detail: t('noLocationData'),
                life: 3000
            });
            return;
        }

        let companyIdToUse;
        if (userInfo?.role == UserRole.AltisAdmin) {
            companyIdToUse = values.selectedCompany
        }
        else {
            companyIdToUse = userInfo?.companyId
        }
        try {
            const locationUserIdsToSend = countingJobLocationTBL.reduce((acc, location) => {
                const locationId = location.locationTBL.locationId;

                if (!acc[locationId]) {
                    acc[locationId] = [];
                }

                if (Array.isArray(location.countingJobResponsibleTBL)) {
                    location.countingJobResponsibleTBL.forEach(responsible => {
                        if (!acc[locationId].includes(responsible.responsibleUserId)) {
                            acc[locationId].push(responsible.responsibleUserId);
                        }
                    });
                }

                selectedUser.forEach(user => {
                    if (!acc[locationId].includes(user.userId)) {
                        acc[locationId].push(user.userId);
                    }
                });

                return acc;
            }, {});

            const addHours = (date, hours) => new Date(date.getTime() + hours * 60 * 60 * 1000)
            const countingJobTBL = {
                companyId: companyIdToUse,
                countingJobId: 0,
                countingJobName: form.getFieldValue("countingJobName"),
                startDate: addHours(new Date(form.getFieldValue("startDate")), 3).toISOString(),
                finishDate: addHours(new Date(form.getFieldValue("finishDate")), 3).toISOString(),
            };

            const dataToSend = {
                countingJobTBL: countingJobTBL,
                locationUserId: locationUserIdsToSend,
            };



            const res = await HTTPService.POST('/CountingJob/registerCounting', dataToSend);


            if (res.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: t('successful'),
                    detail: t('countjobSuccess'),
                    life: 3000
                });
                window.location.replace("/admin/counting-management");
            } else if (res.status === 450) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('mistake'),
                    detail: t(res.data),
                    life: 3000
                });
            } else if (res.status === 452) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('mistake'),
                    detail: t(res.data),
                    life: 3000
                });
            } else if (res.status === 453) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('mistake'),
                    detail: t(res.data),
                    life: 3000
                });
            } else if (res.status === 400) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('mistake'),
                    detail: t(res.data),
                    life: 3000
                });
            }
            else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('mistake'),
                    detail: t('error'),
                    life: 3000
                });
            }
        } catch (error) {
            console.error("Error during updateCounting:", error);
            toast.current?.show({
                severity: 'error',
                summary: t('mistake'),
                detail: t('counting_update_failed'),
                life: 3000
            });
        }
    };

    const columns = [
        {
            title: t('Campus'),
            //dataIndex: 'campusName',
            key: 'campus',
            render: (order) => <div>{order?.locationTBL?.campusTBL?.campusName}</div>,
        },
        {
            title: t('Location'),
            //dataIndex: 'locations',
            key: 'locations',
            render: (order) => <div>{order?.locationTBL?.locationName}</div>,
        },
        {
            title: t('responsible'),
            //dataIndex: 'users',
            key: 'displayName',
            render: (order) => {

                const responsibleUsers = order?.countingJobResponsibleTBL?.map(responsible =>
                    `${responsible.responsibleUserTBL.firstName} ${responsible.responsibleUserTBL.lastName}`
                ).join(", ");

                // const responsibleUsers = countingData?.countingJobResponsibleTBL?.filter(row => row.locationId == order.locationId)
                // .map(responsible => {
                //         return `${responsible.responsibleUserTBL.firstName} ${responsible.responsibleUserTBL.lastName}`
                // }
                //     )
                // .join(", ");

                return <div>{responsibleUsers}</div>;
            },
        },
        {
            title: t('operations'),
            key: 'operations',
            render: (_: any, record: any, index: number) => {

                return (
                    <Button
                        onClick={() => handleDeleteRow(record.countingJobLocationId, record.campusTBL.campusId, record.locationId)}
                        icon={<DeleteOutlined />}
                    >
                    </Button>
                );
            }
        }
    ];

    const handleCompanyChange = (value: number) => {
        getCampusWithLocation(value)
        fetchUser(value || userInfo?.companyId);
    };

    const GetLocationWidget = () => {
        let checkbox: any[] = [];

        allCampusWithLocation
            .filter(filterRow => selectedCampus?.some(x => x.campusId === filterRow.campusId))
            .map((mapRow) => {
                const filteredLocations = mapRow.locationTBL
                    .filter(location => location.locationName.toLowerCase().includes(searchTextLocation))
                    .filter(row => countingJobLocationTBL.filter(x => x.locationId === row.locationId).length == 0);

                filteredLocations.forEach((location: any) => {
                    checkbox.push(
                        <div key={location.locationId}>
                            <Checkbox
                                value={location.locationId}
                                checked={selectedLocation.some(selLoc => selLoc.locationId === location.locationId && selLoc.isSelected)}
                                onChange={() => {
                                    const updatedSelected = selectedLocation.some(selLoc => selLoc.locationId === location.locationId)
                                        ? selectedLocation.filter(selLoc => selLoc.locationId !== location.locationId)
                                        : [...selectedLocation, location];
                                    handleLocationChange(updatedSelected.map(loc => loc.locationId));
                                }}
                            >
                                {location.locationName}
                            </Checkbox>
                        </div>
                    );
                });
            });

        return checkbox;
    };



    return (
        <>
            <Toast ref={toast} />
            <Card style={{ padding: "50px" }}>
                <h3>{t('addCounting')}</h3>
                <Form
                    form={form}
                    onFinish={registerCounting}
                    layout="vertical"
                >
                    {userInfo?.role === UserRole.AltisAdmin ? (
                        <Form.Item
                            name='selectedCompany'
                            label={t('Select company')}
                            rules={[{ required: true, message: t('please_select_a_company') }]}
                        >
                            <Select
                                showSearch
                                placeholder={t('company_name')}
                                style={{ marginBottom: '6px' }}
                                onChange={handleCompanyChange}
                            >
                                {companyData.map((company) => (
                                    <Select.Option key={company.companyId} value={company.companyId}>
                                        {company.companyName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    ) : null}

                    <Form.Item
                        name="countingJobName"
                        label={t('Counting Job Name')}
                        rules={[{ required: true, message: t('inputCounting'), whitespace: true }]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            style={{ borderRadius: 0 }}
                            placeholder={t('Counting Job Name')}
                        />
                    </Form.Item>


                    <Form.Item
                        name='startDate'
                        label={
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Tooltip title={t('counting_start_date_info')}>
                                    <InfoCircleOutlined style={{
                                        color: '#1890ff',
                                        cursor: 'pointer',
                                        fontSize: '16px'
                                    }} />
                                </Tooltip>
                                {t('Counting Start Date')}
                            </div>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('pleaseCounting'),
                            },
                        ]}
                    >
                        <DatePicker
                            style={{ width: '100%', borderRadius: 0 }}
                            placeholder={t('Counting Start Date')}
                            format="DD.MM.YYYY HH:mm"
                            showTime={{ format: 'HH:mm' }}
                        />
                    </Form.Item>

                    <Form.Item
                        name='finishDate'
                        label={
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Tooltip title={t('counting_finish_date_info')}>
                                    <InfoCircleOutlined style={{
                                        color: '#1890ff',
                                        cursor: 'pointer',
                                        fontSize: '16px'
                                    }} />
                                </Tooltip>
                                {t('Counting Finish Date')}
                            </div>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('pleaseCountingFinish'),
                            },
                        ]}
                    >
                        <DatePicker
                            style={{ width: '100%', borderRadius: 0 }}
                            placeholder={t('Counting Finish Date')}
                            format="DD.MM.YYYY HH:mm"
                            showTime={{ format: 'HH:mm' }}
                        />
                    </Form.Item>


                    <Form.Item>
                        <Row gutter={[8, 8]}>
                            <Col span={8}>
                                <Form.Item label={t('campus')}>
                                    <Input
                                        placeholder={t('search_campus')}
                                        style={{
                                            marginBottom: '10px',
                                            borderRadius: '0px',
                                            marginTop: '-25px',
                                        }}
                                        allowClear
                                        onChange={(e) => {
                                            const searchText = e.target.value.toLowerCase();
                                            setSearchText(searchText);
                                        }}
                                        className="custom-search-input"
                                    />

                                    <div className="checkbox-group-container">
                                        <Checkbox.Group
                                            value={selectedCampus.map(campus => campus.campusId)}
                                            onChange={handleCampusChange}
                                        >

                                            <div key="selectAllCampus" style={{ marginLeft: '7px' }}>
                                                <p
                                                    onClick={() => {
                                                        if (selectedCampus.length === allCampusWithLocation.length) {
                                                            handleCampusChange([]);
                                                        } else {
                                                            const allCampusIds = allCampusWithLocation.map(row => row.campusId);
                                                            handleCampusChange(allCampusIds);
                                                        }
                                                    }}
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontWeight: 'bold',
                                                        padding: '5px',
                                                        display: 'inline-block',
                                                        marginLeft: '-2px',
                                                        userSelect: 'none',
                                                        marginTop: '5px',
                                                    }}
                                                >
                                                    {t('selectAll')}
                                                </p>
                                            </div>


                                            {allCampusWithLocation
                                                .filter(row =>
                                                    row.campusName.toLowerCase().includes(searchText)
                                                    && row.locationTBL.filter(location =>
                                                        countingJobLocationTBL?.some(x => x.locationId === location.locationId)
                                                    ).length !== row.locationTBL.length
                                                )
                                                .map((row: any, index: number) => (
                                                    <div key={`${row.campusId}-${index}`}>
                                                        <Checkbox value={row.campusId}>{row.campusName}</Checkbox>
                                                    </div>
                                                ))}
                                        </Checkbox.Group>
                                    </div>
                                </Form.Item>

                            </Col>

                            <Col span={8}>

                                <Form.Item label={t('location')}>
                                    <Input
                                        placeholder={t('search_location')}
                                        style={{
                                            marginBottom: '10px',
                                            borderRadius: '0px',
                                            marginTop: '-25px',
                                        }}
                                        allowClear
                                        onChange={(e) => {
                                            const searchText = e.target.value.toLowerCase();
                                            setSearchTextLocation(searchText); // searchTextLocation'ı güncelledik
                                        }}
                                        className="custom-search-input"
                                    />
                                    <div className="checkbox-group-container">
                                        <div>
                                            <p
                                                onClick={() => {
                                                    const selectedCampusIds = selectedCampus.map(campus => campus.campusId);

                                                    // Seçili kampüslerin bağlı olduğu tüm lokasyonları al
                                                    const totalLocationIds = allCampusWithLocation
                                                        .filter(campus => selectedCampusIds.includes(campus.campusId))
                                                        .flatMap(campus => campus.locationTBL.map(location => location.locationId));

                                                    // Seçili olan lokasyonları (already selected) çıkart
                                                    const selectedLocationIds = countingJobLocationTBL.map(loc => loc.locationId);

                                                    // Tüm lokasyonlardan sadece seçili olmayanları al
                                                    const unselectedLocationIds = totalLocationIds.filter(locationId => !selectedLocationIds.includes(locationId));

                                                    // Eğer tüm lokasyonlar zaten seçildiyse, hiçbir şey yapma (tümünü kaldır)
                                                    if (selectedLocation.length === totalLocationIds.length) {
                                                        handleLocationChange([]); // Tümünü kaldır
                                                    } else {
                                                        // Seçili olmayanları seç
                                                        handleLocationChange(unselectedLocationIds); // Sadece seçilmeyenleri ekle
                                                    }
                                                }}
                                                style={{
                                                    cursor: 'pointer',
                                                    fontWeight: 'bold',
                                                    padding: '5px',
                                                    display: 'inline-block',
                                                    marginLeft: '-2px',
                                                    userSelect: 'none',
                                                    marginTop: '5px',
                                                }}
                                            >
                                                {t('selectAll')}
                                            </p>
                                        </div>

                                        <Checkbox.Group value={selectedLocation.map(loc => loc.locationId)} onChange={handleLocationChange}>
                                            <div>
                                                {GetLocationWidget()}
                                            </div>
                                        </Checkbox.Group>
                                    </div>
                                </Form.Item>

                            </Col>
                            <Col span={8}>
                                <Form.Item label={t('responsible')}>
                                    <Input
                                        placeholder={t('search_responsible')}
                                        style={{
                                            marginBottom: '10px',
                                            borderRadius: '0px',
                                            marginTop: '-25px',
                                        }}
                                        allowClear
                                        onChange={(e) => {
                                            const searchText = e.target.value.toLowerCase();
                                            if (!searchText) {
                                                setFilteredUserData(userData);
                                            } else {
                                                const filtered = userData.filter(user =>
                                                    user.displayName.toLowerCase().includes(searchText)
                                                );
                                                setFilteredUserData(filtered);
                                            }
                                        }}
                                        className="custom-search-input"
                                    />
                                    <div className="checkbox-group-container">
                                        <>
                                            <Checkbox.Group
                                                value={selectedUser.map(user => user.userId)}
                                                onChange={handleUserChange}
                                            >
                                                <div key="all" style={{ marginLeft: '7px' }}>
                                                    <p
                                                        onClick={() => {
                                                            if (selectedUser.length === userData.length) {
                                                                handleUserChange([]);
                                                            } else {
                                                                const allUserIds = userData.map(row => row.userId);
                                                                handleUserChange(allUserIds);
                                                            }
                                                        }}
                                                        style={{
                                                            cursor: 'pointer',
                                                            fontWeight: 'bold',
                                                            padding: '5px',
                                                            display: 'inline-block',
                                                            marginLeft: '-10px',
                                                            userSelect: 'none',
                                                            marginTop: '5px',
                                                        }}
                                                    >
                                                        {t('selectAll')}
                                                    </p>
                                                </div>

                                                {filteredUserData.map(user => (
                                                    <div key={user.userId}>
                                                        {selectedLocation.length > 0 && (
                                                            <Checkbox value={user.userId}>{user.displayName}</Checkbox>
                                                        )}
                                                    </div>
                                                ))}
                                            </Checkbox.Group>
                                        </>
                                    </div>
                                </Form.Item>
                            </Col>


                        </Row>
                    </Form.Item>

                    <Col xs={8} sm={4}>
                        <Tooltip title={t('addTable')}>
                            <Button
                                block
                                onClick={handleAddToTable}
                                type="primary"
                                style={{
                                    borderRadius: 8,
                                    width: '140px',
                                    height: '45px',
                                    border: 'none',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.25)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                                }}
                            >
                                <TableOutlined style={{ fontSize: '18px' }} />
                                <span>{t('addTable')}</span>
                            </Button>
                        </Tooltip>
                    </Col>
                    <br />
                    <Form.Item>
                        <Table
                            dataSource={countingJobLocationTBL}
                            columns={columns}
                            pagination={false}
                            key={"key"}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Row gutter={[4, 4]} justify="end" align="middle">
                            <Col xs={12} sm={4}>
                                <Button
                                    block
                                    onClick={handleCancel}
                                    type="primary"
                                    style={{
                                        height: 64,
                                        backgroundColor: 'transparent',
                                        color: '#1890ff',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0 10px',
                                        border: 'none',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                        e.currentTarget.style.color = '#40a9ff';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.color = '#1890ff';
                                    }}
                                >
                                    <CloseOutlined style={{ fontSize: 20 }} />
                                    <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                        {t('cancel')}
                                    </span>
                                </Button>
                            </Col>
                            <Col xs={12} sm={4}>
                                <Button
                                    block
                                    htmlType="submit"
                                    type="primary"
                                    style={{
                                        height: 64,
                                        backgroundColor: 'transparent',
                                        color: '#1890ff',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0 10px',
                                        border: 'none',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                        e.currentTarget.style.color = '#40a9ff';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.color = '#1890ff';
                                    }}
                                >
                                    <SaveOutlined style={{ fontSize: 20 }} />
                                    <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                        {t('save')}
                                    </span>
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Card>
        </>

    );
};

export default CountingAdd;
